import { tz } from 'moment-timezone';

const getFormatDate = (date: string | null | undefined, format: string): string => {
  if (!date) return '--';

  return tz(date, tz.guess()).format(format);
};

export const formatTimestamp = (date: string | null | undefined): string =>
  getFormatDate(date, 'LLLL z');

export const formatDate = (date: string | null | undefined): string => getFormatDate(date, 'LL');

export const formatTime = (date: string | null | undefined): string =>
  getFormatDate(date, 'LT z');

export const formatPaymentTime = (date: string | null | undefined): string =>
  getFormatDate(date, 'LTS z'); // including the seconds is useful for debugging payment issues

export const formatWashboardTimestamp = (date: string | null | undefined): string =>
  getFormatDate(date, 'MMM D, YYYY h:mm A z');

/*
 * Pipeline audit rows are read against DataDog and against each other, so seconds are required to
 * order events inside a single run — a run can complete in under a second.
 */
export const formatPipelineTimestamp = (date: string | null | undefined): string =>
  getFormatDate(date, 'MM/DD/YY, hh:mm:ss a z');
